import React, { useContext } from 'react';
import styles from '../farmFieldFlow.module.scss';
import { FormType } from 'enums/FieldTypeEnums';
import FieldsRow from 'shared/components/FieldsRow';
import COButton from 'shared/components/COButton';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import {
  DynamicFields,
  LandChangeValue,
  STAGE_4,
} from 'constants/FarmboxConstants/stage4.constants';
import { GetLandChangeFields } from '../stage4FarmHelperData';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { LandChanges, Stage4MetaData } from 'models/Farmbox/field.model';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { useParams } from 'react-router-dom';
import isProductDisabled from 'shared/utils/isProductDisabled';
import clsx from 'clsx';

interface LandUseChangeProps {
  landUseMetaData: Stage4MetaData[];
  harvestYear?: number;
}

const LandUseChangeSection = (props: LandUseChangeProps) => {
  const { control, watch, resetField } = useFormContext();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const { status } = useParams();
  const { harvestYear, landUseMetaData } = props;
  const { REACT_HOOK_FORMS } = FormType;
  const { HEADING, LAND_CHANGES_LABELS } = STAGE_4;
  const { LAND_USE_CHANGE } = HEADING;
  const { ADD_LAND_USE } = LAND_CHANGES_LABELS;
  const isDisabled = isProductDisabled(status);

  const landUseChangeLength = watch('commodity.landUseChanges')?.length;
  const {
    fields: landUseChangeFields,
    append: landUseChangeAppend,
    remove: removeLandUse,
  } = useFieldArray({
    control: control,
    name: DynamicFields.LAND_USE_DYNAMIC,
  });
  const handleAddLandUseChange = () => {
    landUseChangeAppend(new LandChanges());
  };

  return (
    <>
      <div className={styles.contentContainer}>
        <div className={styles.fieldHeaderContainer}>
          <h2 className={styles.headingContainer}>{LAND_USE_CHANGE}</h2>
          <div
            className={clsx(styles.addAction, {
              [styles.hideAction]: isDisabled,
            })}>
            <COButton text onClick={handleAddLandUseChange}>
              <AddIcon />
              {ADD_LAND_USE}
            </COButton>
          </div>
        </div>
        <div className={styles.fieldRow}>
          <div className={styles.formFieldsContainer}>
            {landUseChangeFields.map((land, index) => (
              <div key={land.id} className={styles.formFieldsContainer}>
                <FieldsRow
                  {...GetLandChangeFields({
                    remove: removeLandUse,
                    index,
                    type: LandChangeValue.USED,
                    landUseMetaData,
                    harvestYear,
                    landUseChangeLength,
                    fetchData,
                    isDisabled,
                    resetField,
                  })}
                  formType={REACT_HOOK_FORMS}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandUseChangeSection;
